import { createRoot } from 'react-dom/client'
import './styles/global.scss'
import './i18n'
import App from './App.tsx'
import { initPerformanceMonitoring } from './utils/performance'

// 初始化性能监控
initPerformanceMonitoring();

// 注意：暂时禁用 StrictMode 以避免 echarts-for-react 在开发环境的双重卸载问题
// 这不影响生产环境的行为，只是在开发时避免控制台错误
createRoot(document.getElementById('root')!).render(
  <App />
)
